// extracted by mini-css-extract-plugin
export default {"toggleButton":"ToggleButton_toggleButton__tsQ8M"};